<template>
	<ul class="pools_ul" v-bind:id="params.name">
		<h3 class="label_radio">{{getLabel(params.label)}}  <span v-if="params.compulsory" class="star">*</span>:</h3>
		<div class="template_input pools pools_checkbox">
			<li v-for="(value, key) in params.choices" class="pool" v-bind:class=" checkboxRes.includes(key) || all_selected ? 'selected' : ''" v-on:click="active_pool">
				<input type="checkbox" v-bind:id="'answer_'+key" v-bind:value="key" v-model="checkboxRes">
				<label v-bind:for="'answer_'+key" class="poolLabel">{{getLabel(value.label)}}</label>
			</li>
			<li v-if="this.params.allInputs" class="pool" v-bind:class="all_selected ? 'selected' : ''" id="li_all_sectors" v-on:click="all_selected = !all_selected">
				<input type="checkbox" id="answer_all_sectors" value="all_sectors">
				<label for="answer_all_sectors" class="poolLabel">{{getLabel(all_sector_label)}}</label>
			</li>
		</div>
		<ul class="order" v-if="this.params.allInputs && params.order && this.all_selected">
			<li>
				<span></span>
				<p> {{getLabel(all_sector_label)}}</p>
				<div class="icon delete" v-on:click="all_selected = false"></div>
			</li>
		</ul>
		<ul class="order" v-if="params.order && checkboxRes.length">
			<li v-for="(value, key) in checkboxRes">
				<span>{{key + 1}}</span>
				<p> {{getLabel(params.choices[value].label)}}</p>
				<div class="icon delete" v-on:click="delete_pool(value)"></div>
			</li>
		</ul>
	</ul>
</template>

<script>

import componentTools from '@/libs/componentTools.js';
import lib from '@/libs/main.js';

export default {
	name: 'pools_checkbox_input',
	data() {
		return {
			checkboxRes : [],
			all_sector_label: {
				fr: "Tous les secteurs",
				en: "All fields"
			},
			all_selected : false
		}
	},
	props : ['params', 'oldValue', 'lang', 'templateIndex'],
	methods : {
		validate : function(val) {
			if(this.all_selected) return true;
			if(this.params && this.params.flex_limit) return val.length <= this.params.flex_limit && val.length > 0;
			if(this.params && this.params.limit) return val.length >= this.params.limit;
			return val.length;
		},
		notifyUpdate : function(val) {
			this.$emit('validateField', this.params.name, val);
		},
		getLabel : componentTools.getLabel,
		active_pool : function(event){
			if(this.all_selected) return;

			const target = event.target.firstChild;
			const val = parseInt(target.value);

			if(!isNaN(val) && this.checkboxRes.indexOf(val) > -1) return this.delete_pool(val);
			if(this.params && this.params.flex_limit && this.checkboxRes.length >= this.params.flex_limit) return;
			if(this.params && this.params.limit && this.checkboxRes.length >= this.params.limit) return;
			if(!isNaN(val)) this.checkboxRes.push(val);
		},
		delete_pool : function(value){
			this.checkboxRes = this.checkboxRes.filter(e => e != value);
		}
	},
	watch: {
		checkboxRes : function(val){
			const element = document.getElementById(this.params.name);
			if(!this.all_selected) {
				if(this.validate(val)) {
					this.notifyUpdate(val);
					if(element && !this.params.flex_limit){
						element.getElementsByClassName("pools_checkbox")[0].classList.add("limit");
					}
					if(element && this.params.flex_limit){
						if(this.params.flex_limit == val.length) element.getElementsByClassName("pools_checkbox")[0].classList.add("limit");
						else element.getElementsByClassName("pools_checkbox")[0].classList.remove("limit");
					}
				} else {
					this.notifyUpdate();
					if(element) element.getElementsByClassName("pools_checkbox")[0].classList.remove("limit");
				}
			}
		},
		oldValue : function(val, oldv){
			const element = document.getElementById(this.params.name);
			if(!val) {
				this.checkboxRes = [];
				if(element) element.getElementsByClassName("pools_checkbox")[0].classList.remove("limit");
			} else if(Array.isArray(val)) this.checkboxRes = JSON.parse(JSON.stringify(val));
			else if(val && val.all_selected) this.all_selected  = true;
		},
		all_selected : function(val) {
			this.checkboxRes = [];
			const elem = document.getElementById(this.params.name).getElementsByClassName("pools_checkbox")[0].classList;
			if(val) {elem.add("limit"); this.notifyUpdate({all_selected : true});}
			else {elem.remove("limit"); this.notifyUpdate();}
		},
		templateIndex : function(val, oldv) {
			if(!this.oldValue && val > oldv) {
				this.checkboxRes = [];
				document.getElementsByClassName("pools_checkbox")[0].classList.remove("limit");
			}
		}
	},
	mounted : function(){
		if(Array.isArray(this.oldValue) && this.oldValue.length) this.checkboxRes = JSON.parse(JSON.stringify(this.oldValue));
		else if(this.oldValue && this.oldValue.all_selected) this.all_selected = true;
	}
};
</script>
<style lang="less">
@import '../../assets/less/conf.import.less';
.pools_checkbox.limit {
	li {
		cursor: not-allowed;
		.selected {
			opacity: 75;
		}
	}
}
.pools_ul .order {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}
.pools_ul .order li {
	display: flex;
	padding: 10px;
	align-items: center;
	border-radius: 5px;
	width: 60%;
	justify-content: space-between;
	flex-direction: row;
	p {
		font-size: 14px;
	}
	span {
		color: #fff;
		font-size: 25px;
		font-weight: bold;
	}
	.icon {
		cursor: pointer;
		position: relative;
	}
}
.pools {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: center;
	li {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 106px;
		user-select : none;
		height: 56px;
		vertical-align: middle;
		margin-top: @margin;
		margin-left: @margin;
		margin-right: @margin;
		border-radius: 5px;
		border: 1px solid @cGrey_Light_3;
		cursor: pointer;
		z-index: 1;
	}
	input[type="checkbox"] {
		display: none !important;
	}
	.poolLabel{
		width: 100%;
		padding: 5px;
		max-width: 100% !important;
		margin-top: 10px !important;
		display: inline-block;
		text-align: center !important;
		position: relative !important;
		word-break: break-word;
		margin : @margin auto;
		font-size: 12px !important;
		z-index: 2;
		pointer-events: none;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/candidate_forms/pools_checkbox_input.vue